var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"arrow lightboxPrev",attrs:{"href":_vm.previous}},[_c('i',{staticClass:"fas fa-arrow-left"})])
}
var staticRenderFns = []

export { render, staticRenderFns }